// import React from 'react';
// import { NavLink, Outlet, useNavigate } from 'react-router-dom';
// import { BarChart3, Building2, CreditCard, FileCode2, LayoutTemplate, LogOut, Megaphone, ShieldCheck, UsersRound } from 'lucide-react';
// import { getUser, removeToken } from '../api/auth';

// const items = [
//   ['Overview', '/admin', BarChart3],
//   ['Organizations', '/admin/organizations', Building2],
//   ['Templates', '/admin/templates', LayoutTemplate],
//   ['Creatives', '/admin/creatives', FileCode2],
//   ['Campaigns', '/admin/campaigns', Megaphone],
//   ['Subscriptions', '/admin/subscriptions', CreditCard],
//   ['Plans', '/admin/plans', ShieldCheck],
//   ['Organization users', '/admin/users', UsersRound],
// ];

// export default function AdminLayout() {
//   const navigate = useNavigate();
//   const user = getUser();

//   const logout = () => {
//     removeToken();
//     localStorage.clear();
//     localStorage.removeItem('ctv_user');
//     localStorage.removeItem('ctv_token');
//     navigate('/');
//   };

//   return <div className="min-h-screen bg-slate-50 text-slate-800 md:flex">
//     <aside className="w-full bg-slate-950 px-4 py-5 text-slate-300 md:fixed md:inset-y-0 md:w-64">
//       <div className="mb-8 flex items-center gap-3 px-3 text-white">
//         <span className="grid h-9 w-9 place-items-center rounded-xl bg-indigo-500 font-bold">S</span>
//         <div>
//           <p className="font-semibold">SocialTV</p>
//           <p className="text-xs text-slate-400">Super Admin</p>
//         </div>
//       </div>

//       <nav className="grid grid-cols-2 gap-1 md:block">
//         {
//           items.map(([label, to, Icon]) => <NavLink end={to === '/admin'} key={to} to={to} className={({ isActive }) => `mb-1 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition ${isActive ? 'bg-indigo-500 text-white shadow-lg shadow-indigo-950/30' : 'hover:bg-slate-800 hover:text-white'}`}>
//             <Icon size={17} />{label}</NavLink>
//           )}
//       </nav>

//       <button onClick={logout} className="mt-6 flex w-fit items-center gap-3 rounded-lg px-3 py-2.5 text-sm hover:bg-slate-800 hover:text-white md:absolute md:bottom-6">
//         <LogOut size={17} />Sign out
//       </button>
//     </aside>

//     <main className="min-w-0 flex-1 md:ml-64">
//       <header className="flex items-center justify-between border-b border-slate-200 bg-white px-5 py-4 sm:px-8">
//         <div>
//           <p className="text-sm text-slate-500">Platform administration</p>
//           <h1 className="text-lg font-semibold">Welcome, {user?.name || 'Admin'}</h1>
//         </div>
//         <span className="rounded-full bg-indigo-50 px-3 py-1 text-xs font-semibold text-indigo-700">Super Admin</span>
//       </header>
//       <div className="p-5 sm:p-8">
//         <Outlet />
//       </div>
//     </main>
//   </div>;
// }

import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import {
  BarChart3,
  Building2,
  CreditCard,
  FileCode2,
  LayoutTemplate,
  LogOut,
  Megaphone,
  ShieldCheck,
  UsersRound,
  Menu,
  X,
} from 'lucide-react';
import { getUser, removeToken } from '../api/auth';

const items = [
  ['Overview', '/admin', BarChart3],
  ['Organizations', '/admin/organizations', Building2],
  ['Templates', '/admin/templates', LayoutTemplate],
  ['Creatives', '/admin/creatives', FileCode2],
  ['Campaigns', '/admin/campaigns', Megaphone],
  ['Subscriptions', '/admin/subscriptions', CreditCard],
  ['Plans', '/admin/plans', ShieldCheck],
  ['Organization users', '/admin/users', UsersRound],
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const user = getUser();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const logout = () => {
    removeToken();
    localStorage.clear();
    localStorage.removeItem('ctv_user');
    localStorage.removeItem('ctv_token');
    navigate('/');
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">

      {/* ================= MOBILE HEADER ================= */}
      <header className="sticky top-0 z-40 flex h-16 items-center justify-between border-b border-slate-200 bg-white px-4 md:hidden">

        <div className="flex items-center gap-3">

          {/* Hamburger */}
          <button
            type="button"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open sidebar"
            className="
              grid h-10 w-10 place-items-center
              rounded-lg border border-slate-200
              text-slate-600
              transition
              hover:bg-slate-50
              active:scale-95
            "
          >
            <Menu size={20} />
          </button>

          {/* Logo */}
          <div className="flex items-center gap-2.5">
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-[#ff6968] font-bold text-white">
              S
            </span>

            <div>
              <p className="text-sm font-semibold text-slate-900">
                SocialTV
              </p>

              <p className="text-[10px] text-slate-400">
                Super Admin
              </p>
            </div>
          </div>

        </div>

        {/* Mobile Role */}
        <span className="rounded-full bg-[#ff69681a] px-3 py-1 text-[11px] font-semibold text-[#ff6968]">
          Super Admin
        </span>

      </header>


      {/* ================= MOBILE OVERLAY ================= */}
      {sidebarOpen && (
        <button
          type="button"
          aria-label="Close sidebar"
          onClick={closeSidebar}
          className="
            fixed inset-0 z-40
            cursor-default
            bg-black/40
            backdrop-blur-[2px]
            md:hidden
          "
        />
      )}


      {/* ================= SIDEBAR ================= */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-50
          flex w-[270px] flex-col
          bg-white
         
          text-slate-600
          border-r border-slate-200
          shadow-xl

          transform
          transition-transform
          duration-700
         ease-[cubic-bezier(0.22,1,0.36,1)]

          ${sidebarOpen ? "translate-x-0" : "-translate-x-[110%]"}

          md:translate-x-0
          md:w-64
          md:shadow-none
        `}
      >
        {/* ================= SIDEBAR HEADER ================= */}
        <div className="flex items-center justify-between  px-4 py-5  border-b border-slate-200">
          <div className="flex items-center gap-3 text-slate-900">
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-[#ff6968] font-bold text-white">
              S
            </span>

            <div>
              <p className="font-semibold text-slate-900">
                SocialTV
              </p>
              <p className="text-xs text-slate-400">
                Super Admin
              </p>
            </div>
          </div>

          {/* Mobile Close Button */}
          <button
            type="button"
            onClick={closeSidebar}
            aria-label="Close sidebar"
            className="
              grid h-9 w-9 place-items-center
              rounded-lg
              text-slate-400
              transition
              hover:bg-[#FFE2DE]
              hover:text-[#e95555]
              active:scale-95
              md:hidden
            "
          >
            <X size={20} />
          </button>
        </div>

        {/* ================= NAVIGATION ================= */}
        <nav className="flex-1 flex flex-col gap-1.5 space-y-1 overflow-y-auto  px-4 py-5">
          {items.map(([label, to, Icon]) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/admin"}
              onClick={closeSidebar}
              className={({ isActive }) => `
                flex items-center gap-3
                rounded-lg
                px-3 py-2.5
                text-sm
                transition-all
                duration-200

                ${isActive
                  ? "bg-[#ff6968] text-white shadow-lg shadow-[#ff696833]"
                  : "text-slate-600 hover:bg-[#FFE2DE] hover:text-[#e95555]"
                }
              `}
            >
              <Icon
                size={17}
                className="shrink-0"
              />

              <span>
                {label}
              </span>
            </NavLink>
          ))}
        </nav>

        {/* ================= SIGN OUT ================= */}
        <div className="mt-4 border-t border-slate-200 px-4 py-4">
          <button
            type="button"
            onClick={logout}
            className="
        flex w-full items-center gap-3
        rounded-lg
        px-3 py-2.5
        text-sm
        text-slate-600
        transition
        hover:bg-[#FFE2DE]
        hover:text-[#e95555]
      "
          >
            <LogOut size={17} />

            <span>
              Sign out
            </span>
          </button>
        </div>
      </aside>


      {/* ================= MAIN CONTENT ================= */}
      <main className="min-w-0 md:ml-64">

        {/* ================= DESKTOP HEADER ================= */}
        <header className="hidden items-center justify-between border-b border-slate-200 bg-white px-5 py-4 sm:px-8 md:flex">
          <div>
            <p className="text-sm text-slate-500">
              Platform administration
            </p>
            <h1 className="text-lg font-semibold text-slate-900">
              Welcome, {user?.user_name || 'Admin'}
            </h1>
          </div>

          <span className="rounded-full bg-[#ff69681a] px-3 py-1 text-xs font-semibold text-[#ff6968]">
            Super Admin
          </span>
        </header>


        {/* ================= PAGE CONTENT ================= */}
        <div className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
